import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import {
  adminAracMuayeneExcel,
  adminDorseCezaExcel,
  adminDorseMuayeneExcel,
} from "../../../features/admin2/admin2Slice";

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: 550px;
    height: auto;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-block: 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content {
      padding: 20px;
      button {
        margin-block: 10px;
      }
    }
    .btn {
      padding-inline: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const AdminAraclarİslemlerOptions = () => {
  const { modalLocation } = useSelector((state) => state.modal);
  const { selectAdminArac, isLoadingMuayeneExcel, isLoadingDorseMuayeneExcel, isLoadingDorseCezaExcel } = useSelector((state) => state.admin2);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Ekle"} />
        <div className="content">
            
            <Button handleClick={()=>dispatch(adminAracMuayeneExcel())} bgColor="transparent" borderColor="#E85446" color="#E85446" width={"100%"}>{isLoadingMuayeneExcel ? "İndiriliyor lütfen bekleyiniz..." : "Kamyon ve Çekici Muayeneleri"}</Button>
            <Button handleClick={() => dispatch(adminDorseMuayeneExcel())} bgColor="transparent" borderColor="#E85446" color="#E85446" width={"100%"}>{isLoadingDorseMuayeneExcel ? "İndiriliyor lütfen bekleyiniz..." : "Dorse Muayeneleri"}</Button>
            <Button bgColor="transparent" borderColor="#E85446" color="#E85446" width={"100%"}>Kamyon ve Çekici Cezaları (Henüz çalışmıyor.)</Button>
            <Button handleClick={() => dispatch(adminDorseCezaExcel())} bgColor="transparent" borderColor="#E85446" color="#E85446" width={"100%"}>{isLoadingDorseCezaExcel ? "İndiriliyor lütfen bekleyiniz..." : "Dorse Cezaları"}</Button>
        </div>
        <div className="btn">
          <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" bgColor="#E85446" color={"#fff"}>
            Kapat
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default AdminAraclarİslemlerOptions;
